<script>
  import { createEventDispatcher } from "svelte";
  import TrashCan from "carbon-icons-svelte/lib/TrashCan.svelte";
  import Add from "carbon-icons-svelte/lib/Add.svelte";
  import Star from "carbon-icons-svelte/lib/Star.svelte";
  import StarFilled from "carbon-icons-svelte/lib/StarFilled.svelte";
  import User from "carbon-icons-svelte/lib/User.svelte";
  import PhoneInput from "../../components/PhoneInput.svelte";

  const dispatch = createEventDispatcher();

  export let contacts = [];

  function setNewRow() {
    return {
      name: "",
      phone: "",
      email: "",
      position: "",
      main: contacts.length === 0
    };
  }

  function addRow() {
    contacts = [...contacts, setNewRow()];
  }

  function deleteRow(contactToDelete) {
    const wasMain = contactToDelete.main;
    contacts = contacts.filter(c => c !== contactToDelete);
    if (wasMain && contacts.length > 0) {
      contacts[0].main = true;
      contacts = [...contacts];
    }
  }

  function setMainContact(targetContact) {
    contacts = contacts.map(c => ({
      ...c,
      main: c === targetContact
    }));
  }
</script>

<div class="contacts-component">
  <div class="contacts-header-bar">
    <div class="header-left">
      <span class="contacts-title">Company Contacts</span>
      {#if contacts && contacts.length > 0}
        <span class="contacts-count-pill">{contacts.length} Contact{contacts.length > 1 ? "s" : ""}</span>
      {/if}
    </div>
    <button class="add-contact-btn" on:click={addRow} type="button">
      <Add size={14} />
      <span>Add Contact</span>
    </button>
  </div>

  {#if contacts && contacts.length > 0}
    <div class="contacts-table-card">
      <div class="contacts-row header-row">
        <div class="action-cell"></div>
        <div class="action-cell" title="Primary Contact">Main</div>
        <div class="cell">Name</div>
        <div class="cell">Phone</div>
        <div class="cell">Email</div>
        <div class="cell">Position</div>
      </div>

      {#each contacts as contact, index (contact)}
        <div class="contacts-row data-row {contact.main ? 'is-primary-row' : ''}">
          <div class="action-cell">
            <button
              class="delete-btn"
              on:click={() => deleteRow(contact)}
              title="Delete Contact"
              aria-label="Delete Contact"
              type="button"
            >
              <TrashCan size={14} />
            </button>
          </div>
          <div class="action-cell">
            <button
              class="main-toggle-btn {contact.main ? 'is-main' : ''}"
              on:click={() => setMainContact(contact)}
              title={contact.main ? "Primary Company Contact" : "Click to set as Primary Contact"}
              aria-label={contact.main ? "Primary Company Contact" : "Set as Primary Contact"}
              type="button"
            >
              {#if contact.main}
                <StarFilled size={16} />
              {:else}
                <Star size={16} />
              {/if}
            </button>
          </div>
          <div class="cell">
            <input
              type="text"
              class="contact-input"
              placeholder="Full name"
              bind:value={contact.name}
            />
          </div>
          <div class="cell">
            <PhoneInput
              id={`contact-phone-${index}`}
              showIcon={false}
              placeholder="0412 345 678"
              bind:value={contact.phone}
            />
          </div>
          <div class="cell">
            <input
              type="email"
              class="contact-input"
              placeholder="name@company.com.au"
              bind:value={contact.email}
            />
          </div>
          <div class="cell">
            <input
              type="text"
              class="contact-input"
              placeholder="e.g. Director, Estimator"
              bind:value={contact.position}
            />
          </div>
        </div>
      {/each}
    </div>
  {:else}
    <div class="contacts-empty-box">
      <div class="empty-icon-wrap">
        <User size={20} />
      </div>
      <div class="empty-text-wrap">
        <span class="empty-title">No company contacts recorded</span>
        <span class="empty-sub">Add personnel to enable quick contact selection on proposals</span>
      </div>
      <button class="empty-add-btn" on:click={addRow} type="button">
        <Add size={13} />
        <span>Add First Contact</span>
      </button>
    </div>
  {/if}
</div>

<style>
  .contacts-component {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  .contacts-header-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2px;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .contacts-title {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #475569;
  }

  .contacts-count-pill {
    font-size: 10.5px;
    font-weight: 600;
    color: #0369a1;
    background: #e0f2fe;
    padding: 1px 7px;
    border-radius: 9999px;
  }

  .add-contact-btn {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    font-size: 11.5px;
    font-weight: 600;
    color: #0284c7;
    background-color: rgba(2, 132, 199, 0.08);
    border: 1px solid rgba(2, 132, 199, 0.22);
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .add-contact-btn:hover {
    background-color: rgba(2, 132, 199, 0.16);
    border-color: #0284c7;
  }

  .contacts-table-card {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #ffffff;
    overflow: hidden;
  }

  .contacts-row {
    display: grid;
    grid-template-columns: 30px 30px 1.2fr 1fr 1.3fr 1fr;
    gap: 8px;
    align-items: center;
    padding: 6px 10px;
    border-bottom: 1px solid #f1f5f9;
  }

  .contacts-row:last-child {
    border-bottom: none;
  }

  .header-row {
    font-size: 10.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #64748b;
    background-color: #f8fafc;
    padding: 8px 10px;
    border-bottom: 1px solid #e2e8f0;
  }

  .data-row {
    transition: background-color 0.12s ease;
  }

  .data-row:hover {
    background-color: #f8fafc;
  }

  .data-row.is-primary-row {
    background-color: rgba(254, 243, 199, 0.15);
  }

  .action-cell {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .delete-btn {
    background: transparent;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: all 0.15s ease;
    padding: 0;
  }

  .delete-btn:hover {
    color: #ef4444;
    background-color: #fee2e2;
  }

  .main-toggle-btn {
    background: transparent;
    border: none;
    color: #cbd5e1;
    cursor: pointer;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: all 0.15s ease;
    padding: 0;
  }

  .main-toggle-btn.is-main {
    color: #f59e0b;
  }

  .main-toggle-btn:hover {
    color: #f59e0b;
    background-color: #fef3c7;
  }

  .cell {
    width: 100%;
  }

  .contact-input {
    width: 100%;
    height: 32px;
    padding: 0 8px;
    font-size: 12px;
    color: #1e293b;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    background-color: #ffffff;
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .contact-input:focus {
    border-color: #0284c7;
    box-shadow: 0 0 0 2px rgba(2, 132, 199, 0.15);
  }

  .contact-input::placeholder {
    color: #94a3b8;
  }

  :global(.contacts-row .tt-phone-input-wrapper) {
    width: 100% !important;
  }

  :global(.contacts-row .tt-phone-input-wrapper .tt-tel-control) {
    margin: 0 !important;
    height: 32px !important;
    font-size: 12px !important;
    padding: 0 8px !important;
    border-radius: 6px !important;
    border: 1px solid #cbd5e1 !important;
    background-color: #ffffff !important;
  }

  :global(.contacts-row .tt-phone-input-wrapper .tt-tel-control:focus) {
    border-color: #0284c7 !important;
    box-shadow: 0 0 0 2px rgba(2, 132, 199, 0.15) !important;
  }

  /* Empty state */
  .contacts-empty-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 16px;
    border: 1px dashed #cbd5e1;
    border-radius: 8px;
    background-color: #f8fafc;
  }

  .empty-icon-wrap {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #e2e8f0;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .empty-text-wrap {
    display: flex;
    flex-direction: column;
    gap: 1px;
    flex: 1;
  }

  .empty-title {
    font-size: 12px;
    font-weight: 600;
    color: #334155;
  }

  .empty-sub {
    font-size: 11px;
    color: #64748b;
  }

  .empty-add-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 5px 12px;
    font-size: 11.5px;
    font-weight: 600;
    color: #0284c7;
    background-color: #ffffff;
    border: 1px solid #0284c7;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;
  }

  .empty-add-btn:hover {
    background-color: rgba(2, 132, 199, 0.08);
  }
</style>